import React, { useCallback, useEffect } from "react";
import styles from "./TopWords.module.sass";
import TableComponent from "../../../../../components/TableComponent";
import { BiPlus } from "react-icons/bi";
import useState from "react-usestateref";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../../../../components/Modal";
import { fetchCards } from "../../../../../app/cards/cards.slice";

const columns = [
  {
    header: "Card",
    accessor: "cardName",
  },
  {
    header: "Actions",
    accessor: "actions",
  },
];

const TopWords = ({ cardsSelected, setCardsSelected, isEdit }) => {
  const dispatch = useDispatch();

  const { cards } = useSelector((state) => state);

  const [visibleModal, setVisibleModal] = useState(false);
  const [cardsTable, setCardsTable] = useState([]);

  const [cardTable, setCardTable] = useState([]);

  useEffect(() => {
    dispatch(
      fetchCards({
        take: 100,
        skip: 0,
      })
    );
  }, [dispatch]);

  const handleSearchCard = (e) => {
    dispatch(
      fetchCards({
        take: 100,
        skip: 0,
        search: e,
      })
    );
  };

  const handleDeleteCardTableID = useCallback((id) => {
    setCardTable((prev) => {
      const filtered = prev?.filter((c) => c._id !== id) ?? [];
      setCardsSelected(filtered?.map((c) => c?._id));
      return filtered;
    });
  }, [setCardTable, setCardsSelected]);

  const handleParseDataCard = useCallback((card) => {
    return {
      cardName: {
        data: card?.meaning?.trans,
        dataComponent: card?.meaning?.trans,
      },
      _id: card?._id,
      actions: {
        data: "actions",
        dataComponent: (
          <div style={{ display: "flex", alignItems: "center" }}>
            <button className={styles.linkAction} onClick={() => window.open(`/card/edit/${card?._id}`, "_blank")}>
              View
            </button>
            <button className={styles.linkActionDanger} onClick={() => handleDeleteCardTableID(card?._id)}>
              Delete
            </button>
          </div>
        ),
      },
    };
  }, [handleDeleteCardTableID]);

  const handleAddCardTableID = useCallback((card) => {
    if (!cardTable?.find((c) => c._id === card?._id)) {
      let _cardTable = [...cardTable, handleParseDataCard(card)];
      setCardTable(_cardTable);
      setCardsSelected(_cardTable?.map((c) => c?._id));
      setVisibleModal(false);
    }
  }, [cardTable, handleParseDataCard, setCardTable, setCardsSelected, setVisibleModal]);

  useEffect(() => {
    if (isEdit && cardsSelected && cardTable.length === 0) {
      const parsedCards = cardsSelected?.map((c) => handleParseDataCard(c)) ?? [];
      if (parsedCards.length > 0) {
        setCardTable(parsedCards);
      }
    }
  }, [cardTable.length, cardsSelected, handleParseDataCard, isEdit, setCardTable]);

  useEffect(() => {
    if (cards?.value) {
      setCardsTable(
        cards?.value?.map((card) => {
          return {
            cardName: {
              data: card?.meaning?.trans,
              dataComponent: card?.meaning?.trans,
            },
            _id: card?._id,
            actions: {
              data: "actions",
              dataComponent: (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <button className={styles.linkAction} onClick={() => handleAddCardTableID(card)} title="Add">
                    <BiPlus size="20" />
                  </button>
                </div>
              ),
            },
          };
        })
      );
    }
  }, [cards, handleAddCardTableID]);

  const handleShowModalAddDeck = () => {
    setVisibleModal(true);
  };

  return (
    <div>
      <Modal outerClassName={styles.outer} visible={visibleModal} onClose={() => setVisibleModal(false)}>
        <div className={styles.modalContent}>
          <TableComponent
            className={styles.keywordsModal}
            tableClassName={styles.keywordsTable}
            title="Keywords"
            data={cardsTable}
            columns={columns}
            handleSearchAPI={handleSearchCard}
            embedded
            isCardStyle={false}
          />
        </div>
      </Modal>
      <TableComponent
        data={cardTable}
        columns={columns}
        isButton={true}
        buttonText="Add Keyword"
        buttonIcon={<BiPlus size="24" />}
        buttonHandler={handleShowModalAddDeck}
        title="Keywords"
      />
    </div>
  );
};

export default TopWords;
